// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import DateText from '../../../DateText.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  gastrointestinal: Object,
}

class ViewGastrointestinal extends Component<Props> {
  render() {
    const gastrointestinal = this.props.gastrointestinal || {};
    return (
      <ContentBox title='Gastrointestinal'>
        <div className={styles.col}>
          <PrimaryText>Mouth/Gums/Teeth</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Gums and mouth:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.gumsMouth' initialValue={gastrointestinal.gumsMouth}>
              <Radio disabled value='good' />Good condition, no lesions or sores<br />
              <Radio disabled value='good now' />History of lesions or sores, none now<br />
              <Radio disabled value='lesion' />Current oral mucosa/gum lesion or sore<br />
              <Radio disabled value='erythema' />Erythema of oral mucosa<br />
              <Radio disabled value='white patches' />White patches on oral mucosa<br />
              <Radio disabled value='mucositis' />Mucositis (stomatitis)<br />
              <Radio disabled value='gingivitis' />Gingivitis/reddened gums
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Teeth/bridges/dentures:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.teethDentures' initialValue={gastrointestinal.teethDentures}>
              <Radio disabled value='good' />Teeth in good condition<br />
              <Radio disabled value='fair' />Teeth in fair condition<br />
              <Radio disabled value='poor' />Teeth in poor condition<br />
              <Radio disabled value='no teeth' />No natural teeth<br />
              <Radio disabled value='bridges' />Bridges (describe)<br />
              <Radio disabled value='upper dentures' />Upper dentures only<br />
              <Radio disabled value='lower dentures' />Lower dentures only<br />
              <Radio disabled value='upper lower' />Upper and lower dentures<br />
              <Radio disabled value='edentulous' />None, edentulous
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Mouth/gums/teeth Notes:</SecondaryText><br />
            <TextArea disabled field='gastrointestinal.mouthNotes' initialValue={gastrointestinal.mouthNotes} />
          </div>
          <PrimaryText>Esophageal</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Esophageal assessment (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.swallowProblems' initialValue={gastrointestinal.swallowProblems} />Swallowing problems<br />
            <Checkbox disabled field='gastrointestinal.refluxEating' initialValue={gastrointestinal.refluxEating} />Reflux after eating<br />
            <Checkbox disabled field='gastrointestinal.refluxBending' initialValue={gastrointestinal.refluxBending} />Reflux when bending over<br />
            <Checkbox disabled field='gastrointestinal.refluxLying' initialValue={gastrointestinal.refluxLying} />Reflux when lying down<br />
            <Checkbox disabled field='gastrointestinal.heartburn' initialValue={gastrointestinal.heartburn} />Frequent heartburn
          </div>
          <div className={styles.section}>
            <SecondaryText>Esophageal notes:</SecondaryText><br />
            <TextArea disabled field='gastrointestinal.esophagealNotes' initialValue={gastrointestinal.esophagealNotes} />
          </div>
          <PrimaryText>Abdomen</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Abdominal assessment (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.softAb' initialValue={gastrointestinal.softAb} />Soft<br />
            <Checkbox disabled field='gastrointestinal.firmAb' initialValue={gastrointestinal.firmAb} />Firm<br />
            <Checkbox disabled field='gastrointestinal.flatAb' initialValue={gastrointestinal.flatAb} />Flat<br />
            <Checkbox disabled field='gastrointestinal.roundedAb' initialValue={gastrointestinal.roundedAb} />Rounded<br />
            <Checkbox disabled field='gastrointestinal.ascites' initialValue={gastrointestinal.ascites} />Ascites<br />
            <Checkbox disabled field='gastrointestinal.nontenderToPalp' initialValue={gastrointestinal.nontenderToPalp} />Nontender to palpation<br />
            <Checkbox disabled field='gastrointestinal.tenderToLightPalp' initialValue={gastrointestinal.tenderToLightPalp} />Tender to light palpation<br />
            <Checkbox disabled field='gastrointestinal.tenderToDeepPalp' initialValue={gastrointestinal.tenderToDeepPalp} />Tender to deep palpation<br />
            <Checkbox disabled field='gastrointestinal.guardingToPalp' initialValue={gastrointestinal.guardingToPalp} />Guarding to palpation<br />
            <Checkbox disabled field='gastrointestinal.rigidToPalp' initialValue={gastrointestinal.rigidToPalp} />Rigid to palpation<br />
            <br />
            <SecondaryText>If tender on palpation, indicate region:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.rightUpperPalp' initialValue={gastrointestinal.rightUpperPalp} />Right upper quadrant<br />
            <Checkbox disabled field='gastrointestinal.leftUpperPalp' initialValue={gastrointestinal.leftUpperPalp} />Left upper quadrant<br />
            <Checkbox disabled field='gastrointestinal.rightLowerPalp' initialValue={gastrointestinal.rightLowerPalp} />Right lower quadrant<br />
            <Checkbox disabled field='gastrointestinal.leftLowerPalp' initialValue={gastrointestinal.leftLowerPalp} />Left lower quadrant<br />
            <Checkbox disabled field='gastrointestinal.epigastric' initialValue={gastrointestinal.epigastric} />Epigastric<br />
            <Checkbox disabled field='gastrointestinal.periumbilical' initialValue={gastrointestinal.periumbilical} />Periumbilical<br />
            <Checkbox disabled field='gastrointestinal.generalized' initialValue={gastrointestinal.generalized} />Generalized
          </div>
          <PrimaryText>Gastrointestinal</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='gastrointestinal.noGastricProblems' initialValue={gastrointestinal.noGastricProblems} />No gastric problems noted<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.nausea' initialValue={gastrointestinal.nausea} />Nausea<br />
            <Checkbox disabled field='gastrointestinal.vomiting' initialValue={gastrointestinal.vomiting} />Vomiting<br />
            <Checkbox disabled field='gastrointestinal.epigastricPain' initialValue={gastrointestinal.epigastricPain} />Epigastric pain/distress<br />
            <Checkbox disabled field='gastrointestinal.hemoptysis' initialValue={gastrointestinal.hemoptysis} />Hemoptysis<br />
            <Checkbox disabled field='gastrointestinal.hematemesis' initialValue={gastrointestinal.hematemesis} />Hematemesis<br />
            <Checkbox disabled field='gastrointestinal.abPainCramp' initialValue={gastrointestinal.abPainCramp} />Abdominal pain, cramping<br />
            <Checkbox disabled field='gastrointestinal.abPainSharp' initialValue={gastrointestinal.abPainSharp} />Abdominal pain, sharp
          </div>
          <div className={styles.section}>
            <SecondaryText>Gastrointestinal notes:</SecondaryText><br />
            <TextArea disabled field='gastrointestinal.gastroNotes' initialValue={gastrointestinal.gastroNotes} />
          </div>
          <PrimaryText>Intestinal</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Date of last bowel movement: </SecondaryText>
            <DateText field='gastrointestinal.lastBowel' item={{ 'gastrointestinal.lastBowel': gastrointestinal.lastBowel }} initEmpty />
          </div>
          <div className={styles.section}>
            <SecondaryText>Continence of bowel:</SecondaryText><br />
            <RadioGroup field='gastrointestinal.continenceBowel' initialValue={gastrointestinal.continenceBowel}>
              <Radio disabled value='continent' />Continent<br />
              <Radio disabled value='incontinent' />Incontinent<br />
              <Radio disabled value='occasional incontinent' />Occasionally incontinent
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Bowel sounds (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.activeSound' initialValue={gastrointestinal.activeSound} />Active x 4 quadrants<br />
            <Checkbox disabled field='gastrointestinal.hyperactiveSound' initialValue={gastrointestinal.hyperactiveSound} />Hyperactive<br />
            <Checkbox disabled field='gastrointestinal.hypoactiveSound' initialValue={gastrointestinal.hypoactiveSound} />Hypoactive/sluggish<br />
            <Checkbox disabled field='gastrointestinal.notHeard' initialValue={gastrointestinal.notHeard} />Not heard<br />
            <Checkbox disabled field='gastrointestinal.otherSound' initialValue={gastrointestinal.otherSound} />Other (describe in Notes)
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal assessment:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.noBowelProbs' initialValue={gastrointestinal.noBowelProbs} />No bowel problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.occasionalDiar' initialValue={gastrointestinal.occasionalDiar} />Occasional diarrhea<br />
            <Checkbox disabled field='gastrointestinal.frequentDiar' initialValue={gastrointestinal.frequentDiar} />Frequent diarrhea<br />
            <Checkbox disabled field='gastrointestinal.explosiveDiar' initialValue={gastrointestinal.explosiveDiar} />Explosive diarrhea<br />
            <Checkbox disabled field='gastrointestinal.occasionalConst' initialValue={gastrointestinal.occasionalConst} />Occasional constipation<br />
            <Checkbox disabled field='gastrointestinal.frequentConst' initialValue={gastrointestinal.frequentConst} />Frequent constipation<br />
            <Checkbox disabled field='gastrointestinal.bloating' initialValue={gastrointestinal.bloating} />Bloating<br />
            <Checkbox disabled field='gastrointestinal.frequentBelch' initialValue={gastrointestinal.frequentBelch} />Frequent belching<br />
            <Checkbox disabled field='gastrointestinal.frequentFlat' initialValue={gastrointestinal.frequentFlat} />Frequent flatulence
          </div>
          <div className={styles.section}>
            <SecondaryText>Stool characteristics (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.firm' initialValue={gastrointestinal.firm} />Firm<br />
            <Checkbox disabled field='gastrointestinal.loose' initialValue={gastrointestinal.loose} />Loose<br />
            <Checkbox disabled field='gastrointestinal.watery' initialValue={gastrointestinal.watery} />Watery<br />
            <Checkbox disabled field='gastrointestinal.hard' initialValue={gastrointestinal.hard} />Hard<br />
            <Checkbox disabled field='gastrointestinal.brown' initialValue={gastrointestinal.brown} />Brown<br />
            <Checkbox disabled field='gastrointestinal.black' initialValue={gastrointestinal.black} />Black<br />
            <Checkbox disabled field='gastrointestinal.green' initialValue={gastrointestinal.green} />Green<br />
            <Checkbox disabled field='gastrointestinal.gray' initialValue={gastrointestinal.gray} />Gray<br />
            <Checkbox disabled field='gastrointestinal.yellow' initialValue={gastrointestinal.yellow} />Yellow<br />
            <Checkbox disabled field='gastrointestinal.tarry' initialValue={gastrointestinal.tarry} />Tarry<br />
            <Checkbox disabled field='gastrointestinal.tan' initialValue={gastrointestinal.tan} />Tan<br />
            <Checkbox disabled field='gastrointestinal.rusty' initialValue={gastrointestinal.rusty} />Rusty<br />
            <Checkbox disabled field='gastrointestinal.bloodStreaked' initialValue={gastrointestinal.bloodStreaked} />Blood-streaked<br />
            <Checkbox disabled field='gastrointestinal.frankBlood' initialValue={gastrointestinal.frankBlood} />Frank blood<br />
            <Checkbox disabled field='gastrointestinal.foulOdor' initialValue={gastrointestinal.foulOdor} />Foul odor
          </div>
          <div className={styles.section}>
            <SecondaryText>Rectum:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.noRectalProbs' initialValue={gastrointestinal.noRectalProbs} />No reported rectal problems
          </div>
          <div className={styles.section}>
            <SecondaryText>Rectum characteristics (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.redness' initialValue={gastrointestinal.redness} />Redness<br />
            <Checkbox disabled field='gastrointestinal.irritation' initialValue={gastrointestinal.irritation} />Irritation<br />
            <Checkbox disabled field='gastrointestinal.hemorrhoids' initialValue={gastrointestinal.hemorrhoids} />Hemorrhoids<br />
            <Checkbox disabled field='gastrointestinal.analFistula' initialValue={gastrointestinal.analFistula} />Anal fistula<br />
            <Checkbox disabled field='gastrointestinal.analAbscess' initialValue={gastrointestinal.analAbscess} />Anal abscess<br />
            <Checkbox disabled field='gastrointestinal.analFissure' initialValue={gastrointestinal.analFissure} />Anal fissure<br />
            <Checkbox disabled field='gastrointestinal.rectalProlapse' initialValue={gastrointestinal.rectalProlapse} />Rectal prolapse<br />
            <Checkbox disabled field='gastrointestinal.rectalItching' initialValue={gastrointestinal.rectalItching} />Rectal itching<br />
            <Checkbox disabled field='gastrointestinal.rectalTrauma' initialValue={gastrointestinal.rectalTrauma} />Rectal trauma
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal diversion:</SecondaryText><br />
            <Checkbox disabled field='gastrointestinal.ostomy' initialValue={gastrointestinal.ostomy} />Patient has ostomy
          </div>
          <div className={styles.section}>
            <SecondaryText>Intestinal notes:</SecondaryText><br />
            <TextArea disabled field='gastrointestinal.intestinalNotes' initialValue={gastrointestinal.intestinalNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewGastrointestinal;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewGastrointestinal.jsx